import * as React from "react";

import { BaseDialogFormComponent } from "./BaseDialogFormComponent"

export interface ISimpleDialogFormComponent {
    title: any;
    body: any;
    buttons: JSX.Element[];
}

export class SimpleDialogFormComponent extends BaseDialogFormComponent<ISimpleDialogFormComponent> {
    constructor(props: ISimpleDialogFormComponent) {
        super(props);
    }
    title() { return this.props.title; }
    body() { return this.props.body;  }
    buttons() { return this.props.buttons; }
    error(): any { return null; }
}



// WEBPACK FOOTER //
// ./Scripts/React/Component/SimpleDialogFormComponent.tsx